import React from "react";
import Button from "../../../components/Button/Button";
import { FaPlus, FaSearch } from "react-icons/fa";

const Toolbar = ({
  total,
  actives,
  search,
  onSearch,
  statusFilter,
  onStatusFilter,
  onNew,
}) => {
  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2">
        <div className="rounded-xl border border-gray-200/70 dark:border-slate-700/70 bg-white/70 dark:bg-slate-800/70 backdrop-blur shadow-sm px-4 py-2 text-sm">
          Total : <strong>{total}</strong> • Actives : <strong>{actives}</strong>
        </div>
      </div>

      <div className="flex flex-1 sm:flex-none items-center gap-2 sm:justify-end">
        <div className="relative w-full sm:w-72">
          <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Rechercher (nom, lieu, niveau)"
            className="w-full rounded-xl border border-gray-200/70 dark:border-slate-700/70 bg-white/70 dark:bg-slate-800/70 backdrop-blur px-9 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-primary"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
          />
        </div>

        <select
          value={statusFilter}
          onChange={(e) => onStatusFilter(e.target.value)}
          className="rounded-xl border border-gray-200/70 dark:border-slate-700/70 bg-white/70 dark:bg-slate-800/70 px-3 py-2 text-sm"
          aria-label="Filtrer par statut"
        >
          <option value="all">Tous les statuts</option>
          <option value="active">Actives</option>
          <option value="inactive">Inactives</option>
        </select>

        <Button
          onClick={onNew}
          icon={FaPlus}
          hoverLabel="Créer une nouvelle compétition"
          variant="brand"
          size="sm"
          className="rounded-xl"
        >
          Nouvelle compétition
        </Button>
      </div>
    </div>
  );
};

export default Toolbar;
